/**
 * Determines the MIME type for a file based on its extension
 *
 * @param {string} filename - The filename to check
 * @returns {string} The appropriate MIME type
 */
export const determineMimeType = (filename) => {
  if (filename.endsWith('.json')) {
    return 'application/json';
  } else if (filename.endsWith('.csv')) {
    return 'text/csv';
  } else if (filename.endsWith('.feature')) {
    return 'text/plain';
  }
  return 'text/plain';
};
